import React, { useState } from 'react'
import { isEmailValid } from '../../utils/helpers'

export default function EmailStep({ loading, error, onSubmit }) {
  const [email, setEmail] = useState('')
  const [localError, setLocalError] = useState('')

  function handleSubmit(e) {
    e.preventDefault()
    if (!email.trim() || !isEmailValid(email)) {
      setLocalError('Voer een geldig emailadres in')
      return
    }
    setLocalError('')
    onSubmit(email.trim())
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div>
        <label htmlFor="email" className="form-label">Email adres</label>
        <input
          id="email"
          type="email"
          autoComplete="email"
          value={email}
          onChange={(e) => { setEmail(e.target.value); setLocalError('') }}
          className={`form-input ${(localError || error) ? 'border-red-300 focus:border-red-500 focus:ring-red-500' : ''}`}
          placeholder="jouw@email.nl"
          disabled={loading}
          autoFocus
        />
        {(localError || error) && (
          <p className="mt-1 text-sm text-red-600 dark:text-red-400">{localError || error}</p>
        )}
      </div>
      <button type="submit" className="btn btn-primary w-full text-lg py-3" disabled={loading}>
        {loading ? (
          <span className="flex items-center justify-center space-x-2">
            <span className="animate-spin rounded-full h-5 w-5 border-b-2 border-white" />
            <span>Controleren...</span>
          </span>
        ) : 'Doorgaan'}
      </button>
    </form>
  )
}
